// extracted by mini-css-extract-plugin
module.exports = {"list":"list_list__VGYa8","item":"list_item__xDIyJ","itemLarge":"list_itemLarge__W0iHK","loadMoreButton":"list_loadMoreButton__IrwVX"};